import React from 'react';

import { dashboardConfig } from 'config/routeConfigurations/dashboardConfig/dashboardConfig';
import { Link } from 'react-router-dom';

import { CustomizedTooltip } from 'components/common/CustomizedTooltip/CustomizedTooltip';
import { TooltipPosition } from 'components/common/CustomizedTooltip/customizedTooltip.enums';
import { ReportFavoriteIcon } from 'components/common/ReportFavoriteIcon/ReportFavoriteIcon';
import classes from 'components/common/Tables/Cells/ReportLinkWithFavouritesCell/ReportLinkWithFavouritesCell.module.scss';

interface Props {
    id: number;
    name: string;
    isFavorite: boolean;
}

export const ReportLinkWithFavouritesCell = ({ isFavorite, id, name }: Props) => {
    return (
        <div className={classes.linkWithBookmarkContainer}>
            <CustomizedTooltip
                tooltipPosition={TooltipPosition.Bottom}
                tooltipContent={name}
                triggerElement={
                    <Link className={classes.reportName} to={`${dashboardConfig.reporting.link}/${id}`}>
                        {name}
                    </Link>
                }
            />

            <ReportFavoriteIcon isFavorite={isFavorite} id={id} showLoader={true} />
        </div>
    );
};
